module.exports = __webpack_public_path__ + "img/TrondStart.8bc2edcc.jpg";